<template>
	<div class="iv">
		<!-- //////////////// -->
		<!-- label - Инстансы -->
		<!-- кнопка - Активировать канал -->
		<div :class="device.isMobile ? 'iv__row-m' : 'iv__row'">
			<div :class="device.isMobile ? 'iv__row-label-m' : 'iv__row-label'">
				Инстансы
			</div>
			<!-- TODO временно закомментировано -->

			<!--			<div v-if="!device.isMobile" class="iv__row-activation">-->
			<!--				<UiButton-->
			<!--					@click="onClickActivateChannel"-->
			<!--					label="Активировать канал"-->
			<!--					background-color="var(--theme-color)"-->
			<!--					border-color="var(--theme-color)"-->
			<!--					color="rgb(255, 255, 255)"-->
			<!--					font-weight="600"-->
			<!--					font-size="16px"-->
			<!--				/>-->
			<!--			</div>-->
			<div
				v-if="
					!isAdmin() &&
					!device.isMobile &&
					undefined !== tariffType &&
					1 !== tariffType
				"
				class="iv__row-activation"
			>
				<UiButton
					@click="onClickRedirect('payment')"
					label="Купить канал"
					background-color="var(--theme-color)"
					border-color="var(--theme-color)"
					color="rgb(255, 255, 255)"
					font-weight="600"
					font-size="16px"
				/>
			</div>
		</div>

		<!-- //////////////// -->
		<!-- Вкладки каналов -->
		<div v-if="isShowChannelTabs" class="iv__tabs">
			<button
				v-for="tab in visibleChannelTabs"
				:key="tab.channel"
				type="button"
				:class="{
					'iv__tabs-item': true,
					'iv__tabs-item_active': channel === tab.channel,
					'iv__tabs-item_pending': pendingChannel === tab.channel,
				}"
				:disabled="isInstanceListLoading"
				@click="onClickChannelTab(tab.channel)"
			>
				{{ tab.name }}
			</button>
		</div>

		<!-- //////////////// -->
		<!-- INSTANCE TABLE -->
		<div class="iv__instance">
			<div v-if="isListLoaderVisible" class="iv__instance-loader">
				<EllipsisLoader color="var(--theme-color)" />
			</div>
			<InstanceTable
				v-if="!device.isMobile"
				:items="instances"
				:channel="channel"
				v-on:selected-filters="onClickSelectedFilters"
			/>
			<InstanceTableMob v-if="device.isMobile" :items="instances" />
		</div>

		<!-- //////////////// -->
		<!-- PAGINATION DESKTOP -->
		<div v-if="!device.isMobile" class="iv__pagination">
			<Paginator
				:current-page="currentPage"
				:total-pages="instances.pageCount"
				v-on:selected-page="onClickPagination"
			/>
			<PageSelect
				:current-page="currentPage"
				:total-pages="instances.pageCount"
				v-on:selected-page="onClickPagination"
			/>
		</div>

		<!-- //////////////// -->
		<!-- PAGINATION MOBILE -->
		<div v-if="device.isMobile" class="iv__pagination-m">
			<Paginator
				:current-page="currentPage"
				:total-pages="instances.pageCount"
				v-on:selected-page="onClickPagination"
			/>
		</div>

		<!-- Page select -->
		<div v-if="device.isMobile" class="iv__page-select-m">
			<PageSelect
				:current-page="currentPage"
				:total-pages="instances.pageCount"
				v-on:selected-page="onClickPagination"
			/>
		</div>

		<!-- //////////////// -->
		<!-- Активировать канал (Mobile) -->
		<div v-if="device.isMobile" class="iv__activation-m">
			<!-- TODO временно закомментировано -->

			<!--			<UiButton-->
			<!--				@click="onClickActivateChannel"-->
			<!--				class="iv__activation-m-btn"-->
			<!--				label="Активировать канал"-->
			<!--				background-color="var(--theme-color)"-->
			<!--				border-color="var(--theme-color)"-->
			<!--				color="rgb(255, 255, 255)"-->
			<!--				font-weight="600"-->
			<!--				font-size="16px"-->
			<!--			/>-->
			<UiButton
				v-if="!isAdmin()"
				@click="onClickRedirect('payment')"
				class="iv__activation-m-btn"
				label="Купить канал"
				background-color="var(--theme-color)"
				border-color="var(--theme-color)"
				color="rgb(255, 255, 255)"
				font-weight="600"
				font-size="16px"
			/>
			<div></div>
			<UiFilter @click="onClickShowModalFilters" />
		</div>
	</div>

	<!-- Modal mobile filters -->
	<ModalMobileFilters
		v-if="device.isMobile && modalMobileFilters.isShow"
		:items="instances"
		:channel="channel"
		v-on:selected-filters="onClickSelectedFilters"
	/>

	<!-- Modal activate channel -->
	<ModalActivateChannel v-if="modalActivateChannel.isShow" />
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";
import HeaderDesktop from "@/components/header/HeaderDesktop.vue";
import HeaderMobile from "@/components/header/HeaderMobile.vue";
import ModalHeaderNotify from "@/components/modal/ModalHeaderNotify.vue";
import UiButton from "@/components/ui/UiButton.vue";
import InstanceTable from "@/components/table/InstanceTable.vue";
import { IInstance } from "@/interfaces/IInstance";
import InstanceTableMob from "@/components/table/InstanceTableMob.vue";
import UiFilter from "@/components/ui/UiFilter.vue";
import Paginator from "@/components/pagination/Paginator.vue";
import PageSelect from "@/components/pagination/PageSelect.vue";
import PaginatorMob from "@/components/pagination/PaginatorMob.vue";
import { mapActions, mapGetters } from "vuex";
import { IModal } from "@/interfaces/IModal";
import ModalMobileFilters from "@/components/modal/mobile/ModalMobileFilters.vue";
import ModalActivateChannel from "@/components/modal/ModalActivateChannel.vue";
import { IPaymentChannelDetail } from "@/interfaces/IPaymentChannelDetail";
import EllipsisLoader from "@/components/preloader/EllipsisLoader.vue";

@Options({
	components: {
		EllipsisLoader,
		ModalActivateChannel,
		ModalMobileFilters,
		PaginatorMob,
		PageSelect,
		Paginator,
		UiFilter,
		InstanceTableMob,
		InstanceTable,
		UiButton,
		ModalHeaderNotify,
		HeaderMobile,
		HeaderDesktop,
	},

	computed: {
		...mapGetters("instanceModule", {
			modalMobileFilters: "modalMobileFilters",
			modalActivateChannel: "modalActivateChannel",
			device: "getDevice",
			instances: "getInstances",
			redirect: "redirectGetters",
		}),
		...mapGetters("paymentModule", {
			payChannelDetail: "payChannelDetailGetters",
		}),
		...mapGetters("authModule", {
			checkAuthGetters: "checkAuthGetters",
		}),
	},

	methods: {
		...mapActions("instanceModule", [
			"modalMobileFiltersAction",
			"modalActivateChannelAction",
			"instancesAction",
		]),
		...mapActions("paymentModule", [
			"payActivatedChannelsAction",
			"payChannelDetailAction",
			"payGetBalanceAction",
		]),
	},

	watch: {
		/**
		 * Обработка redirectAction из HeaderDesktop (click по логотипу)
		 * @param value
		 */
		redirect(value: { path: string; page: number }) {
			this.currentPage = value.page;
			this.performRequest();
		},
	},
})
export default class InstanceView extends Vue {
	public totalPage = 1;
	public rowsPerPage = 1;

	// Query params
	public currentPage = 1;
	public partnerId = 0;
	public instanceId = "";
	public token = "";
	public phone = "";
	public statusId = "";
	public channel = "wapi";
	public expireOrder = "";
	public insertOrder = "";
	public pendingChannel = "";
	public isInstanceListLoading = false;
	public isChannelSwitchWaiting = false;
	public channelSwitchTimer = 0;
	public channelSwitchDelay = 350;

	public channelTabs = [
		{
			channel: "wapi",
			name: "Whatsapp",
		},
		{
			channel: "tapi",
			name: "Telegram",
		},
		{
			channel: "max",
			name: "Max",
		},
	];

	// ************************************************************
	// Define mapGetters
	public payChannelDetail: IPaymentChannelDetail;
	public modalMobileFilters: IModal;
	public modalActivateChannel: IModal;
	public device: { isMobile: boolean };
	public instances: IInstance;
	public redirect: { path: string; page: number };
	public checkAuthGetters: { result: number; isAdmin: boolean };

	// ************************************************************
	// Define mapActions
	public modalMobileFiltersAction!: (payload: IModal) => void;
	public modalActivateChannelAction!: (payload: IModal) => void;
	public instancesAction!: (payload: {
		page?: number;
		partnerId?: number;
		instanceId?: string;
		token?: string;
		phone?: string;
		statusId?: string;
		channel?: string;
		expireOrder?: string;
		insertOrder?: string;
	}) => void;
	public payActivatedChannelsAction!: () => Promise<void>;
	public payChannelDetailAction!: () => Promise<void>;
	public payGetBalanceAction!: () => Promise<void>;

	/**
	 * Hook mounted
	 */
	public async mounted() {
		const page = this.$route.query.page;
		const partnerId = this.$route.query.partnerId;
		const instanceId = this.$route.query.instanceId as string;
		const token = this.$route.query.token as string;
		const phone = this.$route.query.phone as string;
		const statusId = this.$route.query.statusId as string;
		// Канал сохраняем из query, чтобы после перезагрузки страницы фильтр не сбрасывался.
		const channel = this.$route.query.channel as string;
		const expireOrder = this.$route.query.expireOrder as string;
		const insertOrder = this.$route.query.insertOrder as string;

		this.currentPage = page !== undefined ? Number(page) : 1;
		this.partnerId = partnerId !== undefined ? Number(partnerId) : 0;
		this.instanceId = instanceId !== "" ? instanceId : "";
		this.token = token !== "" ? token : "";
		this.phone = phone !== "" ? phone : "";
		this.statusId = statusId !== "" ? statusId : "";
		this.channel = this.normalizeChannel(channel);
		this.expireOrder = expireOrder !== "" ? expireOrder : "";
		this.insertOrder = insertOrder !== "" ? insertOrder : "";

		await this.performRequest();

		await this.payActivatedChannelsAction();
		await this.payGetBalanceAction();
		await this.payChannelDetailAction();
	}

	/**
	 * Очищает отложенное переключение вкладки при уходе со страницы.
	 */
	public beforeUnmount() {
		this.clearChannelSwitchTimer();
	}

	public isAdmin() {
		return this.checkAuthGetters.isAdmin;
	}

	/**
	 * Tariff type
	 */
	public get tariffType() {
		return this.payChannelDetail.tariff?.type;
	}

	/**
	 * Показывает loader над списком при ожидании debounce или выполнении запроса.
	 */
	public get isListLoaderVisible() {
		return this.isInstanceListLoading || this.isChannelSwitchWaiting;
	}

	/**
	 * Возвращает вкладки только для каналов, где настроена связь пользователя с партнером.
	 */
	public get visibleChannelTabs() {
		const availableChannels = this.instances?.availableChannels;

		if (!Array.isArray(availableChannels) || availableChannels.length === 0) {
			return [];
		}

		return this.channelTabs.filter((tab) =>
			availableChannels.includes(tab.channel)
		);
	}

	/**
	 * Показывает вкладки только если пользователю доступно больше одного канала.
	 */
	public get isShowChannelTabs() {
		return this.visibleChannelTabs.length > 1;
	}

	/**
	 * Показать модалку с фильтрами для мобильных устройств
	 */
	public onClickShowModalFilters() {
		this.modalMobileFiltersAction({ isShow: true });
	}

	/**
	 * Показать модалку - Активировать канал
	 */
	public onClickActivateChannel() {
		this.modalActivateChannelAction({ isShow: true });
	}

	/**
	 * Возвращает допустимый технический код канала для вкладки.
	 */
	public normalizeChannel(channel?: string): string {
		return ["wapi", "tapi", "max"].includes(channel || "")
			? (channel as string)
			: "wapi";
	}

	/**
	 * Переключает вкладку канала и заново запрашивает список инстансов.
	 */
	public onClickChannelTab(channel: string) {
		const nextChannel = this.normalizeChannel(channel);

		if (
			this.isInstanceListLoading ||
			nextChannel === this.channel ||
			nextChannel === this.pendingChannel
		) {
			return;
		}

		this.pendingChannel = nextChannel;
		this.isChannelSwitchWaiting = true;
		this.clearChannelSwitchTimer();

		// Небольшая задержка схлопывает быстрые клики по вкладкам в один запрос к API.
		this.channelSwitchTimer = window.setTimeout(async () => {
			this.channel = this.pendingChannel;
			this.pendingChannel = "";
			this.currentPage = 1;
			this.isChannelSwitchWaiting = false;

			await this.pushListRoute();
			await this.performRequest();
		}, this.channelSwitchDelay);
	}

	/**
	 * Сбрасывает таймер отложенного переключения вкладки.
	 */
	public clearChannelSwitchTimer() {
		if (this.channelSwitchTimer) {
			clearTimeout(this.channelSwitchTimer);
			this.channelSwitchTimer = 0;
		}
	}

	/**
	 * Выбор страницы
	 * @param currentPage
	 */
	public async onClickPagination(currentPage: number) {
		this.currentPage = currentPage;

		await this.pushListRoute();

		await this.performRequest();
	}

	/**
	 * Переход на другую страницу
	 * @param routeName
	 * @param id
	 */
	public async onClickRedirect(routeName: string, id?: number) {
		this.$router.push({ name: routeName, params: { id: id } });
	}

	/**
	 * Выборка по филльтрам
	 */
	public async onClickSelectedFilters(query: {
		page: number;
		partnerId: number;
		instanceId: string;
		token: string;
		phone: string;
		statusId: string;
		// Таблица передает технический код канала, а API уже переводит его в нужную БД.
		channel: string;
		expireOrder?: string;
		insertOrder?: string;
	}) {
		this.currentPage = query.page;
		this.partnerId = query.partnerId;
		this.instanceId = query.instanceId;
		this.token = query.token;
		this.phone = query.phone;
		this.statusId = query.statusId;
		this.channel = this.normalizeChannel(query.channel || this.channel);
		this.expireOrder = query.expireOrder || "";
		this.insertOrder = query.insertOrder || "";

		await this.pushListRoute();

		await this.performRequest();
	}

	/**
	 * Сохраняет текущие фильтры списка в query параметрах.
	 */
	public async pushListRoute() {
		await this.$router.push({
			path: "/",
			query: {
				page: this.currentPage,
				partnerId: this.partnerId,
				instanceId: this.instanceId,
				token: this.token,
				phone: this.phone,
				statusId: this.statusId,
				channel: this.channel,
				expireOrder: this.expireOrder,
				insertOrder: this.insertOrder,
			},
		});
	}

	/**
	 * Выполняем запрос
	 */
	public async performRequest() {
		this.isInstanceListLoading = true;

		try {
			await this.instancesAction({
				page: this.currentPage,
				partnerId: this.partnerId,
				instanceId: this.instanceId,
				token: this.token,
				phone: this.phone,
				statusId: this.statusId,
				channel: this.channel,
				expireOrder: this.expireOrder,
				insertOrder: this.insertOrder,
			});
		} finally {
			this.isInstanceListLoading = false;
			await this.syncChannelFromResponse();
		}
	}

	/**
	 * Синхронизирует выбранный канал с ответом API, если backend выбрал доступный канал по умолчанию.
	 */
	public async syncChannelFromResponse() {
		const responseChannel = this.instances?.activeChannel;

		if (!responseChannel) {
			return;
		}

		const activeChannel = this.normalizeChannel(responseChannel);

		if (activeChannel && activeChannel !== this.channel) {
			this.channel = activeChannel;
			await this.pushListRoute();
		}
	}
}
</script>

<style scoped lang="scss">
.iv {
	&__row {
		display: flex;
		padding: 38px 24px 8px;
		justify-content: space-between;
	}

	&__row-m {
		display: flex;
		padding: 16px 16px 0;
		justify-content: space-between;
	}

	&__activation-m {
		display: flex;
		padding: 34px 16px;
		justify-content: space-between;
		align-items: center;
	}

	&__activation-m-btn {
		flex-grow: 0.9;
	}

	&__row-label {
		display: flex;
		align-items: center;
		color: rgb(49, 49, 50);
		font-size: 24px;
		font-weight: 600;
	}

	&__row-label-m {
		display: flex;
		align-items: center;
		color: rgb(49, 49, 50);
		font-size: 18px;
		font-weight: 600;
	}

	&__pagination {
		display: flex;
		justify-content: space-between;
		align-items: center;
	}

	&__tabs {
		display: flex;
		gap: 8px;
		padding: 8px 24px 0;
	}

	&__tabs-item {
		padding: 10px 16px;
		border: 1px solid rgb(219, 219, 219);
		border-radius: 8px;
		background: rgb(255, 255, 255);
		color: rgb(49, 49, 50);
		cursor: pointer;
		font-size: 14px;
		font-weight: 600;
	}

	&__tabs-item:disabled {
		cursor: default;
		opacity: 0.72;
	}

	&__tabs-item_active {
		border-color: var(--theme-color);
		background: var(--theme-color);
		color: rgb(255, 255, 255);
	}

	&__tabs-item_pending {
		border-color: var(--theme-color);
		color: var(--theme-color);
	}

	&__instance {
		position: relative;
		min-height: 96px;
	}

	&__instance-loader {
		position: absolute;
		z-index: 2;
		left: 0;
		top: 0;
		display: flex;
		width: 100%;
		height: 100%;
		min-height: 96px;
		align-items: center;
		justify-content: center;
		background: rgba(255, 255, 255, 0.72);
	}

	&__pagination-m {
		display: flex;
		justify-content: center;
		align-items: center;
	}

	&__page-select-m {
		display: flex;
		justify-content: flex-end;
	}

	@media screen and (max-width: 768px) {
		&__tabs {
			padding: 12px 16px 0;
			overflow-x: auto;
		}

		&__tabs-item {
			flex: 0 0 auto;
		}
	}
}
</style>
